export default __webpack_public_path__ + "static/media/Frame2.76dedf42.png";